import { render } from "./how-to-use.vue?vue&type=template&id=66d57afd"
import script from "./how-to-use.js?vue&type=script&lang=js&external"
export * from "./how-to-use.js?vue&type=script&lang=js&external"

import "./how-to-use.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__